import { Box as RebassBox } from 'rebass'
import styled from 'styled-components'

const FormGroup = styled(RebassBox).attrs({
  px: [0, 3],
  py: [2, 3],
})``

export default FormGroup



// WEBPACK FOOTER //
// ./src/components/FormGroup.js